import { Envelope, Compass, Lightning, WhatsappLogo, Phone } from "@phosphor-icons/react";
import { Link } from "react-router-dom";
import { BRAND } from "@/data/services";

// A thin marquee strip ABOVE the main site header.
// All clickable items route to the on-site contact form for tracking + UX consistency.
const ITEMS = [
  { icon: Envelope, label: BRAND.email, to: "/contact" },
  { icon: Phone, label: BRAND.phone_display, href: BRAND.tel_url },
  { icon: WhatsappLogo, label: `WhatsApp ${BRAND.phone_display}`, href: BRAND.whatsapp_url, external: true, accent: "wa" },
  { icon: Compass,  label: "CAD drafting only — we do not perform field surveys" },
  { icon: Lightning, label: "Free sample drafting on your first project", to: "/free-trial" },
  { icon: Compass,  label: "Serving all 50 US States · 24–72 hr turnaround" },
];

export default function AnnouncementBar() {
  // duplicate twice to make seamless loop
  const stream = [...ITEMS, ...ITEMS];

  return (
    <div
      className="bg-zinc-950 text-white border-b border-zinc-800 overflow-hidden"
      data-testid="announcement-bar"
      role="region"
      aria-label="Site announcements"
    >
      <div className="relative h-9 flex items-center">
        <div className="flex animate-marquee whitespace-nowrap font-mono text-[11px] uppercase tracking-[0.18em]">
          {stream.map((it, i) => (
            <span key={i} className="inline-flex items-center gap-2.5 px-6 shrink-0">
              <it.icon
                size={13}
                weight="duotone"
                className={
                  it.label.includes("not perform field")
                    ? "text-amber-400"
                    : it.accent === "wa"
                    ? "text-[#25D366]"
                    : "text-[#66A8FF]"
                }
              />
              {it.to ? (
                <Link to={it.to} className="hover:text-[#66A8FF] transition-colors">
                  {it.label}
                </Link>
              ) : it.href ? (
                <a
                  href={it.href}
                  target={it.external ? "_blank" : undefined}
                  rel={it.external ? "noopener noreferrer" : undefined}
                  className={`hover:transition-colors ${it.accent === "wa" ? "hover:text-[#25D366]" : "hover:text-[#66A8FF]"}`}
                >
                  {it.label}
                </a>
              ) : (
                <span className="text-zinc-300">{it.label}</span>
              )}
              <span className="text-zinc-700">·</span>
            </span>
          ))}
        </div>
      </div>
    </div>
  );
}
